import React, { Component } from 'react'
import { connect } from 'react-redux'
import {browserHistory} from 'react-router'
import Loading from '../Loading/Loading'
import * as MabnaButton from '../Button/Button'
import authSelector from '../../../selectors/authSelector'
import QueryAble from '../SearchAndQueryBar'
import Toolbar from '../Toolbar'
import { FETCH_SUPPORT_TICKETS_REQUEST } from '../../../actions/actions'
import SupportTicketRow from './SupportTicketRow'
import {dateRenderer, statusRenderer, typeRenderer, statusRendererWithColor} from './helpers'
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from "material-ui/Table"

const styles = {
  table: {
    width: "100%",
    fontFamily: "IranYekanRegular",
    direction: "rtl"
  },
  tableHeaderColumn: {
    textAlign: "right",
    whiteSpace: "nowrap",
    width: "auto",
  },
  tableRowColumn: {
    textAlign: "right",
    whiteSpace: "nowrap",
    width: "auto",
  }
}

class SupportTicketListContainer extends Component {
  // constructor(props) {
  //   super(props)
  // }

  componentDidMount() {
    const {
      userType,
      dispatch
    } = this.props

    dispatch({
      type: FETCH_SUPPORT_TICKETS_REQUEST,
      userType,
    })
  //   new Promise((resolve, reject) => {
  //     this.setState({isLoading: true})
  //     dispatch({
  //       type: FETCH_SUPPORT_TICKETS_REQUEST,
  //       userType,
  //       resolve,
  //       reject
  //     })
  //   })
  //   .then(this.setState({isLoading: false}))
  //   .catch(this.setState({isLoading: false}))
  }

  handleRowClick = (row, col) => {
    const ticket = this.props.tickets[row]
    this.onTicketClick(ticket.ticket_code)
  }

  onTicketClick = (ticket_code) => browserHistory.push(`/dashboard/support/ticket/${ticket_code}`)

  render() {
    const {
      isLoading,
      tickets,
      count,
      userType,
    } = this.props

    // if (isLoading) {
    //   return this.renderLoading()
    // }

    const isManager = userType === 'MANAGER'

    const getUserFullName = user => {
      const {
        first_name: firstname,
        last_name: lastname,
      } = user
      let fullname = firstname

      if(lastname) fullname += lastname && ' ' + lastname

      return 'توسط ' + fullname
    }

    const lastActivefullName = (ticket) => {
      const replies = ticket.replies
      const lastActiveUser = (replies && replies.length && replies[replies.length - 1].user) || ticket.user

      return getUserFullName(lastActiveUser)
    }

    return (
      <section className="manager-pages">
        <QueryAble
          noQuery={true}
          itemsCount={count}
          collapsed={false}
          actionType={FETCH_SUPPORT_TICKETS_REQUEST}
          additionalDispatchProperty={{ userType }}
          hideQueryOptions={true}
        >
          {isLoading ? (
            <Loading />
          ) : ( <Table
                style={styles.table}
                selectable={true}
                multiSelectable={false}
                onCellClick={this.handleRowClick}
              >
                <TableHeader
                  displaySelectAll={false}
                  enableSelectAll={false}
                  adjustForCheckbox={false}
                >
                  <TableRow>
                    <TableHeaderColumn style={styles.tableHeaderColumn}>
                      کد
                    </TableHeaderColumn>
                    {isManager && <TableHeaderColumn style={styles.tableHeaderColumn}>
                      فرستنده
                    </TableHeaderColumn>}
                    <TableHeaderColumn style={styles.tableHeaderColumn}>
                      عنوان
                    </TableHeaderColumn>
                    <TableHeaderColumn style={styles.tableHeaderColumn}>
                      نوع
                    </TableHeaderColumn>
                    <TableHeaderColumn style={styles.tableHeaderColumn}>
                      وضعیت
                    </TableHeaderColumn>
                    <TableHeaderColumn style={styles.tableHeaderColumn} colSpan={2}>
                      آخرین بروز رسانی
                    </TableHeaderColumn>
                    <TableHeaderColumn style={styles.tableHeaderColumn}>
                    </TableHeaderColumn>
                  </TableRow>
                </TableHeader>
                <TableBody showRowHover={true} displayRowCheckbox={false}>
                  {tickets && tickets.map((item, i) => {

                    return (
                      <TableRow
                        hoverable={true}
                        selectable={true}
                        key={item.ticket_code}
                      >

                        <TableRowColumn style={styles.tableRowColumn}>
                          {item.ticket_code}
                        </TableRowColumn>
                        {isManager && <TableRowColumn style={styles.tableRowColumn}>
                          {item.user.username}
                        </TableRowColumn>}
                        <TableRowColumn style={styles.tableRowColumn}>
                          {item.title}
                        </TableRowColumn>
                        <TableRowColumn style={styles.tableRowColumn}>
                          {typeRenderer(item.ticket_type)}
                        </TableRowColumn>
                        <TableRowColumn style={styles.tableRowColumn}>
                          {statusRendererWithColor(item.ticket_status)}
                        </TableRowColumn>
                        <TableRowColumn style={styles.tableRowColumn} colSpan={2}>
                          {dateRenderer(item.updated_at)} {lastActivefullName(item)}
                        </TableRowColumn>

                        <TableRowColumn style={styles.tableRowColumn}>
                          <MabnaButton.Primary
                            onClick={() => this.onTicketClick(item.ticket_code)}
                          >
                            مشاهده
                          </MabnaButton.Primary>
                        </TableRowColumn>

                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
            )}
          </QueryAble>
      </section>
    )
  }
}

function mapStateToProps(state) {
  return {
    ...authSelector(state),
    ...state.supportTickets,
  }
}

export default connect(
  mapStateToProps,
)(SupportTicketListContainer)


// WEBPACK FOOTER //
// ./src/components/common/Support/SupportTicketListContainer.js